import axios from "axios";
import { loginURL } from "@/constants";

export default {
    name: "acceso",
    components: {},
    data: () => {
        return {
            form: {
                fields: {
                    user: "",
                    pass: ""
                },
                errors: {
                    user: {
                        state: false,
                        label: []
                    },
                    pass: {
                        state: false,
                        label: []
                    }
                }
            }
        };
    },

    async mounted() {
        //this.$store.dispatch("setLoggedIn", false);
        localStorage.removeItem("loggedIn");
        localStorage.removeItem("userToken");
    },

    computed: {
        loginDisabled() {
            return false; // !this.form.fields.user || !this.form.fields.pass;
        }
    },

    methods: {
        forgotClick() {
            //window.alert("Procedimiento para recuperar usuario/contraseña - no habilitado aún");
            window.alert("Function not yet available");
        },

        async loginClick() {
            try {
                const test = loginURL();
                window.console.log(test);
                const promise1 = axios.post(
                    loginURL(),
                    {
                        usr: this.form.fields.user,
                        pass: this.form.fields.pass
                    },
                    { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
                );
                const datos1 = await promise1;
                const result1 = datos1.data;

                const loginToken = result1.loginToken;
                const loginError = result1.error;
                //window.console.log(loginError);
                //window.console.log(loginToken);
                if (loginError != 0) {
                    //this.form.errors.pass.label = "Usuario o clave incorrecta";
                    this.form.errors.pass.label = "Invalid username or password";
                    this.form.errors.pass.state = true;
                } else {
                    localStorage.loggedIn = true;
                    localStorage.userToken = loginToken;

                    if (this.$route.query.redirect === undefined) {
                        this.$router.push("/resumen");
                    } else {
                        this.$router.replace(this.$route.query.redirect);
                    }
                }
            } catch (e) {
                this.form.errors.pass.label = "Invalid";
                this.form.errors.pass.state = true;
            }
        }
    }
};
